export const getSubdomain = () => {
  if (typeof window === 'undefined') return null;
  
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // Check if we're on localhost, Lovable, or main domain
  if (hostname === 'localhost' || 
      hostname.includes('127.0.0.1') || 
      hostname.includes('lovable.app') ||
      hostname.includes('lovableproject.com') ||
      hostname === 'csoagent.com' ||
      hostname === 'www.csoagent.com') {
    return null;
  }
  
  // Extract subdomain from csoagent.com only
  if (parts.length >= 3 && parts[parts.length - 2] === 'csoagent' && parts[parts.length - 1] === 'com') {
    return parts[0];
  }
  
  return null;
};

export const isMainDomain = () => {
  if (typeof window === 'undefined') return true;
  
  const hostname = window.location.hostname;
  return hostname === 'csoagent.com' || 
         hostname === 'www.csoagent.com' || 
         hostname.includes('localhost') || 
         hostname.includes('127.0.0.1') || 
         hostname.includes('lovable.app') ||
         hostname.includes('lovableproject.com');
};

export const getOrganizationFromSubdomain = async (subdomain: string) => {
  const { supabase } = await import('@/integrations/supabase/client');
  
  try {
    const { data, error } = await supabase
      .from('organizations')
      .select('*')
      .eq('subdomain', subdomain)
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching organization by subdomain:', error);
    return null;
  }
};

// Enhanced subdomain validation
export const validateSubdomain = (subdomain: string): { valid: boolean; error?: string } => {
  if (!subdomain) {
    return { valid: false, error: 'Subdomain is required' };
  }
  
  if (subdomain.length < 3 || subdomain.length > 63) {
    return { valid: false, error: 'Subdomain must be 3-63 characters long' };
  }
  
  if (!/^[a-z0-9-]+$/.test(subdomain)) {
    return { valid: false, error: 'Subdomain can only contain lowercase letters, numbers, and hyphens' };
  }
  
  if (subdomain.startsWith('-') || subdomain.endsWith('-')) {
    return { valid: false, error: 'Subdomain cannot start or end with a hyphen' };
  }
  
  // Reserved subdomains
  const reserved = ['www', 'api', 'admin', 'app', 'mail', 'ftp', 'staging', 'dev', 'test'];
  if (reserved.includes(subdomain)) {
    return { valid: false, error: 'This subdomain is reserved' };
  }
  
  return { valid: true };
};

export const checkSubdomainAvailability = async (subdomain: string) => {
  const { supabase } = await import('@/integrations/supabase/client');
  
  try {
    const { data, error } = await supabase
      .from('organizations')
      .select('id')
      .eq('subdomain', subdomain)
      .maybeSingle();
    
    if (error && error.code !== 'PGRST116') throw error;
    
    return !data; // true if available (no existing record)
  } catch (error) {
    console.error('Error checking subdomain availability:', error);
    return false;
  }
};
